// src/components/date/ToggleDateType.tsx

import { Typography } from '@mui/material'
import { useState } from 'react'

import { DDMMYYYYHHMMSS, getRelativeDate, userLocales } from '../../api'

type Props = {
  date: Date
}

export const ToggleDateType = ({ date }: Props) => {
  const [isDateRelative, setMode] = useState(true)
  const onClick = () => setMode(prev => !prev)

  return (
    <Typography onClick={onClick} sx={{ cursor: 'pointer' }}>
      {isDateRelative === false &&
        new Date(date).toLocaleString(userLocales, DDMMYYYYHHMMSS)}
      {isDateRelative === true && String(getRelativeDate(date))}
    </Typography>
  )
}
